var _rect, _rect2, _line, _circle, _circle2, _circle3, _path, _path2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _polygon, _path3, _path4, _path5, _path6, _polygon2, _path7, _path8, _path9, _path10, _path11, _circle4, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _line2, _line3, _circle5, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMath(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 846,
    height: 605,
    viewBox: "0 0 846 605",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pie graph") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 22,
    width: 822,
    height: 470,
    fill: "#f1f1f1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 1,
    width: 822,
    height: 470,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 26.08661,
    x2: 845,
    y2: 26.08661,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 14,
    r: 7,
    fill: "#ffa5d8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 14,
    r: 7,
    fill: "#ffa5d8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 14,
    r: 7,
    fill: "#ffa5d8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M703.566,473.34136a130.62333,130.62333,0,0,0-92.36465-222.988V380.97671Z",
    transform: "translate(-177.5 -147.0199)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M611.2013,250.35334a130.639,130.639,0,0,0-62.48794,245.35537l62.48794-114.732Z",
    transform: "translate(-177.5 -147.0199)",
    fill: "#ffa5d8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 345.12564,
    width: 25.01299,
    height: 25.01299,
    fill: "#ffa5d8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 189.12987,
    y: 345.12564,
    width: 25.01299,
    height: 25.01299,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 225.25974,
    y: 345.12564,
    width: 25.01299,
    height: 25.01299,
    fill: "#575a89"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 585.16883,
    y: 350.68408,
    width: 102.83117,
    height: 4.16883,
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 585.16883,
    y: 363.19058,
    width: 102.83117,
    height: 4.16883,
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 585.16883,
    y: 375.69707,
    width: 102.83117,
    height: 4.16883,
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "630.349 561.222 632.002 574.994 641.367 579.401 651.833 576.096 658.994 579.401 661.198 566.731 648.528 552.408 630.349 561.222",
    fill: "#ffb9b9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M814.45956,718.7087s-8.54063-9.95667-8.67727-4.97833-18.86617,22.05526-18.86617,22.05526-29.196,8.8139-6.61042,14.32259,72.1638-10.46651,73.81641-13.77172-13.77172-28.64517-15.42433-26.4417S828.78215,719.81044,814.45956,718.7087Z",
    transform: "translate(-177.5 -147.0199)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M793.52655,555.10069s-3.30521,25.89083,0,29.74691,1.6526,11.56825,0,12.67,2.20347,5.50869,4.95782,7.71217,6.61042,12.11911,6.61042,12.11911,14.87346,39.11168,14.87346,42.96776,6.61042,12.11911,6.05955,14.87345,3.85608,11.56825,3.30522,13.22085,7.16129,16.52607,4.95781,18.72954-32.50125,9.91564-30.84864,4.95782,2.75434-11.01738,1.6526-11.01738-6.05955-6.05955-4.95782-8.263-33.05212-60.04469-33.05212-60.04469Z",
    transform: "translate(-177.5 -147.0199)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M814.45956,718.7087s-8.54063-9.95667-8.67727-4.97833-18.86617,22.05526-18.86617,22.05526-29.196,8.8139-6.61042,14.32259,72.1638-10.46651,73.81641-13.77172-13.77172-28.64517-15.42433-26.4417S828.78215,719.81044,814.45956,718.7087Z",
    transform: "translate(-177.5 -147.0199)",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M793.52655,555.10069s-3.30521,25.89083,0,29.74691,1.6526,11.56825,0,12.67,2.20347,5.50869,4.95782,7.71217,6.61042,12.11911,6.61042,12.11911,14.87346,39.11168,14.87346,42.96776,6.61042,12.11911,6.05955,14.87345,3.85608,11.56825,3.30522,13.22085,7.16129,16.52607,4.95781,18.72954-32.50125,9.91564-30.84864,4.95782,2.75434-11.01738,1.6526-11.01738-6.05955-6.05955-4.95782-8.263-33.05212-60.04469-33.05212-60.04469Z",
    transform: "translate(-177.5 -147.0199)",
    opacity: 0.1
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "559.838 554.384 553.778 569.808 556.533 591.292 574.161 590.19 584.076 581.376 584.076 562.647 559.838 554.384",
    fill: "#ffb9b9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M740.64315,720.133s-6.05955-19.83128-9.36477-14.32259a87.16079,87.16079,0,0,0-5.50868,11.01738s-26.99257,17.62779-34.15386,17.62779-13.77172,8.8139-4.407,12.11912,80.9777,7.71216,82.07943,0-1.10173-32.50126-4.40694-29.74691S744.49923,725.64171,740.64315,720.133Z",
    transform: "translate(-177.5 -147.0199)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M726.87143,476.09818s-11.56824,19.83128-12.67,22.03475-7.16129,16.52606,4.40695,22.03475,21.48388-40.21341,21.48388-40.21341Z",
    transform: "translate(-177.5 -147.0199)",
    fill: "#ffb9b9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M738.99055,444.1478s-17.6278,34.15386-14.32259,35.2556,16.52606,7.71216,16.52606,7.71216l6.05956-34.70473Z",
    transform: "translate(-177.5 -147.0199)",
    fill: "#575a88"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M738.99055,444.1478s-17.6278,34.15386-14.32259,35.2556,16.52606,7.71216,16.52606,7.71216l6.05956-34.70473Z",
    transform: "translate(-177.5 -147.0199)",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M740.09228,472.793s-3.85608,28.64518-2.20347,34.70473-1.10174,96.9529,1.10174,101.91071,3.85608,36.90821,3.85608,40.76429-4.407,35.2556-5.50869,38.00994-4.407,12.11911-2.75434,16.52606S758.82182,720.133,762.127,716.277s.55087-15.9752,3.30521-16.52607,6.05956-26.44169,6.05956-26.44169l18.17867-101.35985s34.15386-84.83378,26.4417-93.09681S740.09228,472.793,740.09228,472.793Z",
    transform: "translate(-177.5 -147.0199)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 582.97443,
    cy: 103.2221,
    r: 26.99257,
    fill: "#ffb9b9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M750.55879,272.27676s8.8139,23.13648,7.71216,28.0943,25.89083-8.8139,25.89083-8.8139-1.65261-26.99257,0-34.15386S750.55879,272.27676,750.55879,272.27676Z",
    transform: "translate(-177.5 -147.0199)",
    fill: "#ffb9b9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M824.57343,422.99994c-.121,4.6218-.19823,7.37614-.19823,7.37614s1.6526,25.34-1.10174,33.603-2.75434,14.32259-4.407,19.83128c-.4847,1.603-7.07872,2.46236-16.33872,2.84246-8.49449.34705-19.23091.29749-29.53764.06059-17.06591-.39661-32.97506-1.311-35.65221-1.80132-6.05956-1.10173,1.10174-10.4665-1.10174-15.42432S740.09228,401.18,740.09228,401.18s-.55087-35.80647,2.20348-49.57819,13.22085-35.80646,15.42432-38.56081.55087-4.40695-4.407-7.71216,0-15.97519,0-15.97519c9.36477-7.71216,33.05213-8.8139,33.05213-8.8139s36.35733,37.45907,38.56081,45.17123c1.33305,4.66033.85387,41.888.26992,70.63237C824.97018,407.157,824.73321,416.77513,824.57343,422.99994Z",
    transform: "translate(-177.5 -147.0199)",
    fill: "#575a88"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M778.10222,491.52251s-20.933,42.96776-4.40695,45.7221,24.7891-39.11168,24.7891-39.11168Z",
    transform: "translate(-177.5 -147.0199)",
    fill: "#ffb9b9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M735.23542,236.56021c-.95456-4.62956,2.58357-8.95718,6.30994-11.86548a46.1123,46.1123,0,0,1,28.36939-9.67417c7.22409.03924,14.67976,1.95023,20.13991,6.68055,6.36868,5.51741,9.2738,14.36539,8.73908,22.77467s-4.19195,16.38512-9.125,23.21643c-2.36764,3.27871-6.17014,6.67272-9.95349,5.24377a9.251,9.251,0,0,1-3.68162-3.10971,57.10307,57.10307,0,0,1-6.31115-9.69932c-1.354-2.63119-2.52691-5.4045-4.44595-7.657s-4.80319-3.94663-7.73456-3.54215c-2.42142.33412-4.79667,2.0387-7.10613,1.23786-2.56934-.891-3.19043-4.17648-3.39476-6.88822-.224-2.97233-.06534-6.41538-.89068-9.22555C745.24766,234.53388,735.67905,238.7784,735.23542,236.56021Z",
    transform: "translate(-177.5 -147.0199)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M824.57343,422.99994c-6.1697,22.2496-20.32148,59.74723-21.13124,61.36127-.20389.41316-.5233,1.22292-.9144,2.2916-8.49449.34705-19.23091.29749-29.53764.06059,1.5976-4.17556,3.45947-8.20792,3.45947-9.51348,0-2.75434,13.22085-73.81641,13.22085-73.81641S779.204,371.984,769.83919,345.5423s27.81887-21.20845,27.81887-21.20845C817.48934,319.376,821.07,327.9145,821.07,327.9145s1.74622,46.43822,4.126,68.42889c.61152,5.63541,1.26151,9.66226,1.93355,10.8962C828.011,408.85364,826.821,414.92422,824.57343,422.99994Z",
    transform: "translate(-177.5 -147.0199)",
    opacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M789.67047,306.43062s-25.34,10.4665-15.9752,36.9082S793.52655,401.18,793.52655,401.18,780.3057,472.2421,780.3057,474.99645s-8.263,17.6278-4.95782,20.38214,25.34,8.263,25.89083,5.50869a186.304,186.304,0,0,1,6.05956-18.72954c1.10173-2.20347,26.99256-71.06207,23.68735-77.12162s-6.05955-79.3251-6.05955-79.3251S809.50174,301.4728,789.67047,306.43062Z",
    transform: "translate(-177.5 -147.0199)",
    fill: "#575a88"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M733.566,514.34136,636.2013,422.97671l-57.48794,118.732a130.03537,130.03537,0,0,0,62.48794,15.89138C677.272,557.60009,709.92781,537.9795,733.566,514.34136Z",
    transform: "translate(-177.5 -147.0199)",
    fill: "#575a89"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M733.566,514.34136,636.2013,422.97671l-57.48794,118.732a130.03537,130.03537,0,0,0,62.48794,15.89138C677.272,557.60009,709.92781,537.9795,733.566,514.34136Z",
    transform: "translate(-177.5 -147.0199)",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M725.566,521.34136,633.2013,428.97671l-62.48794,114.732A130.69161,130.69161,0,0,0,725.566,521.34136Z",
    transform: "translate(-177.5 -147.0199)",
    fill: "#575a89"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 397,
    y1: 604,
    x2: 793,
    y2: 604,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 738.08215,
    y1: 604.96019,
    x2: 738.08215,
    y2: 488.86667,
    fill: "#3f3d56",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.08215,
    cy: 488.86667,
    r: 16.41727,
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M915.58215,707.43741s-2.34533-50.44293-50.42446-44.57962",
    transform: "translate(-177.5 -147.0199)",
    fill: "#3f3d56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMath);
export default __webpack_public_path__ + "static/media/math.03310ecaf8a8bd51d5fa79ee68d7bab4.svg";
export { ForwardRef as ReactComponent };